import styled from "styled-components";

interface IProps {
    title?: string;
    imgmission?: string;
    point?: number;
    ticket?: number;
    textButton?: string;
    active?: boolean;
    isWinner?: boolean;
    nameWiner?: string;
    imgWinner?: string;
}

export const ListWinner = (props: IProps) => {
    return (
        <StyledSpinBenefit>
            <div className="img-spin-mission"><img src={props.imgmission || ""} alt="" /></div>
            <h2>{props?.title || "Title"}</h2>
            {props.isWinner ? (
                <div className="winner">
                    <span>
                        <img src={props.imgWinner || "../../images/ic-user-spinwheel.svg"} alt="" />
                    </span>
                    {props.nameWiner || "Nichakar****"}
                </div>
            ) : (
                <div className="nowinner">
                    - No recipient -
                </div>
            )}
        </StyledSpinBenefit>
    );
};

const StyledSpinBenefit = styled.div`
    position: relative;
    padding-left: 60px;
    padding-right: 115px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgb(221, 221, 221);
    display: flex;
    align-items: center;
    min-height: 55px;
    .img-spin-mission {
        position: absolute;
        width: 45px;
        height: 45px;
        border-radius: 16px;
        left: 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    h2 {
        font-size: 14px;
        line-height: 17px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #000;
    }
    .winner {
        position: absolute;
        right: 0px;
        top: 4px;
        display: flex;
        gap: 5px;
        align-items: center;
        color: #FE7B57;
        font-size: 12px;
        line-height: 20px;
    }
    .nowinner {
        position: absolute;
        right: 0px;
        top: 4px;
        display: flex;
        gap: 5px;
        align-items: center;
        color: #9B9B9B;
        font-size: 12px;
        line-height: 20px;
    }
`;